<div
        class="form-group"
        [formGroup]="OBJ_form_group"
        [ngClass]="{'has-error': isInvalid()}">
    <label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
	    <i *ngIf="getHint()" class="fa fa-info-circle"
	       tooltip="{{getHint()|translate}}"
	       placement="top"
	       triggers="click"
	       containerClass="tig-tooltip"
	       delay="50"></i>
        <span *ngIf="isRequired()" class="tgi-asterisk"> *</span>
    </label>
    <ng-container *ngIf="OBJ_field_config.file; else imageupload">
        <div *ngIf="BOO_edit" class="col-lg-8">
            <div class="input-group" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
                <span class="form-control" *ngIf="!BOO_file_loaded">{{"oFile.sNoFile"|translate}}</span>
                <span class="form-control" *ngIf="BOO_file_loaded && !BOO_in_filesystem" >{{OBJ_field_config.filename}}</span>
                <span class="form-control" *ngIf="BOO_file_loaded && BOO_in_filesystem" >{{OBJ_field_config.value}}</span>
                <span class="input-group-addon btn-default" (click)="file_upload.click()">{{"oFile.sSelectFile"|translate}}</span>
                <span *ngIf="!isRequired()" class="input-group-addon btn-default" (click)="reset()">{{"delete"|translate}}</span>
	            <span *ngIf="OBJ_field_config.value && BOO_in_filesystem" class="input-group-addon btn-default" (click)="download(OBJ_field_config.value)">{{"oFile.sShow"|translate}}</span>
			</div>
            <div class="upload-wrapper">
                <input
                    #file_upload
                    type="file"
                    accept="{{allowed_files}}"
                    (change)="fileChangeListener($event)"
                    title="{{'upload'|translate}}"/>
            </div>
	        <div class="tig-hint" *ngIf="OBJ_field_config.note">
		        <span>{{ OBJ_field_config.note|translate}}</span>
	        </div>
            <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
        </div>
        <div *ngIf="!BOO_edit" class="col-lg-8">
            <div>
                <span class="form-control" *ngIf="!BOO_file_loaded">{{"oFile.sNoImage"|translate}}</span>
                <span class="form-control" *ngIf="BOO_file_loaded" >{{OBJ_field_config.filename}}</span>
            </div>
        </div>
    </ng-container>
    <ng-template #imageupload>
        <div *ngIf="BOO_edit" class="col-lg-8">
            <div class="img-wrapper" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (click)="OBJ_file_upload.click()">
                <span *ngIf="!BOO_file_loaded"><i class="fa fa-picture-o"></i><br />{{"oFile.sDropImage"|translate}}</span>
	            <img *ngIf="BOO_file_loaded && !BOO_in_filesystem" [src]="this.STR_uploaded_file"/>
                <img *ngIf="BOO_file_loaded && BOO_in_filesystem" [src]="this.STR_resized_image"/>
            </div>
            <div class="upload-wrapper">

	            <button *ngIf="!isRequired()" class="btn btn-danger btn-circle tig-btn-delete" title="{{'delete'|translate}}" (click)="reset()"><i class="fa fa-trash-o"></i></button>
                <button class="btn btn-primary btn-circle" (click)="OBJ_file_upload.click()"><i class="fa fa-upload"></i></button>

				<input
                    #OBJ_file_upload
                    type="file"
                    accept="image/png,image/jpg,image/jpeg,image/gif,image/svg+xml"
                    (change)="fileChangeListener($event)"
					title="{{'upload'|translate}}"/>
				<button *ngIf="OBJ_field_config.value && BOO_in_filesystem" class="btn btn-success btn-circle" (click)="download(OBJ_field_config.value)"><i class="fa fa-download"></i></button>
            </div>
	        <div class="tig-hint" *ngIf="OBJ_field_config.note">
		        <span>{{ OBJ_field_config.note|translate}}</span>
	        </div>
            <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
        </div>
        <div *ngIf="!BOO_edit" class="col-lg-8">
            <div class="img-wrapper">
                <span *ngIf="!BOO_file_loaded"><i class="fa fa-picture-o"></i><br />{{"oFile.sNoImage"|translate}}</span>
                <img *ngIf="BOO_file_loaded" [src]='this.STR_resized_image'/>
            </div>
        </div>
    </ng-template>
</div>
<div class="form-group" *ngIf="OBJ_field_config?.file_object && BOO_file_loaded && BOO_in_filesystem">
    <label class="col-lg-2 control-label">Url</label>
    <div class="col-lg-8">
        <input readonly
               class="form-control"
               type="text"
               value="{{this.STR_url}}">
    </div>
</div>
<div class="form-group" *ngIf="STR_route_to_self">
    <div class="col-lg-2 control-label"></div>
    <div class="col-lg-8">
        <a href="{{STR_route_to_self}}" target="_blank">{{"oMisc.sEditEntry"|translate}}</a>
    </div>
</div>
